<template>
  <div class="wrp">
    <MobileHome
      :mobileHomeInfo="mobileHomeInfo"
      :salseQRCode="salseQRCode"
      :tutorChatToken="tutorChatToken"
    ></MobileHome>
  </div>
</template>

<script>
import MobileHome from "../components/Mobile/MobileHome";
import { MobileHomeHandler } from "@/handler/MobileHomeHandler.js";
export default {
  components: {
    MobileHome
  },
  data() {
    return {
      mobileHomeInfo: [],
      salseQRCode: "",
      tutorChatToken: ""
    };
  },
  created() {
    document.title = "我的推薦碼";
    this.tutorChatToken = this.$route.query.tct;
    this.mobileHomeInfo = MobileHomeHandler.GetMobileHomeInfo(
      this.tutorChatToken
    );
    this.salseQRCode = MobileHomeHandler.GetSalseQRCodeURL(this.tutorChatToken);
  },
  methods: {}
};
</script>
<style scoped>
#app {
  position: static;
}
</style>


// WEBPACK FOOTER //
// src/views/MobileHomeView.vue